import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NotifierService } from '../../ui';
import { SLEntity } from './entity';
import { SLEntityFilter, SLEntityService } from './entity.service';
import {finalize} from 'rxjs/operators';
import { filter as lodashFilter, size } from 'lodash';

@Component({
  host: {
    '(window:keydown)': 'hotkeys($event)',
    '(window:click)': 'windowClick($event)'
  },
  selector: 't-entity-lookup',
  templateUrl: './entity-lookup.component.html'
})
export class SLEntityLookupComponent implements OnInit {
  @Input() control: FormControl

  @Input() hideId: string

  search: string

  lastSearch: string
  searchTimer: any

  entities: SLEntity[]
  selectedItem: SLEntity

  closed: boolean = true

  @ViewChild('host')
  host: ElementRef
  
  constructor(
    private entityService: SLEntityService,
    private notifier: NotifierService
  ) {}

  ngOnInit() {
    if (this.control) {
      this.control.registerOnChange((entity: SLEntity) => {
        this.updateState();
      })
    }
  }

  updateState() {
    if (this.control && this.control.value) {
      const entity = this.control.value as SLEntity;

      this.selectedItem = entity;
      this.search = this.lastSearch = entity.name;
    }
  }

  get showItems() {
    return !this.closed && this.entities && this.entities.length > 0;
  }

  select(entity: SLEntity) {
    if (this.control) {
      this.control.setValue(entity);
    }

    this.close();
  }
  
  close() {
    this.updateState();

    this.closed = true;
  }

  get hasSelection() {
    return this.closed && this.control && this.control.value && this.selectedItem && (this.control.value as SLEntity).id === this.selectedItem.id;
  }

  apply() {
    this.closed = false;

    let filter = new SLEntityFilter();
    filter.search = this.search;
    filter.offset = 0;
    filter.limit = 10;
    filter.orderBy = 'NAME';
    filter.orderDir = 'ASC';

    this.notifier.startProgress();

    this.entityService
      .entities(filter).pipe(
      finalize(() => this.notifier.endProgress()))
      .subscribe((result) => {
        if(this.hideId) {
          this.entities = lodashFilter(result.entities, entity => {
            return entity.id !== this.hideId;
          });
        }
        else {
          this.entities = result.entities;
        }

        if(size(this.entities) > 0) {
          this.selectedItem = this.entities[0];
        }
      });

  }

  hotkeys(event: KeyboardEvent){
    
    switch(event.keyCode) {
      // Escape key
      case 27:
        this.close();
        break;
      // Enter key
      case 13:
        if(size(this.entities) && this.selectedItem) {
          this.select(this.selectedItem);
        }
        event.preventDefault();
        return false;
      // Up Arrow key
      case 38:
        if(size(this.entities) > 0) {
          let selectedIndex = this.entities.indexOf(this.selectedItem);

          if(selectedIndex >= 0) {
            selectedIndex -= 1;

            if(selectedIndex >= 0) {
              this.selectedItem = this.entities[selectedIndex];
            }
          }
        }
        break;
      // Down Arrow key
      case 40:
        if(size(this.entities) > 0) {
          let selectedIndex = this.entities.indexOf(this.selectedItem);

          if(selectedIndex >= 0) {
            selectedIndex += 1;

            if(selectedIndex < this.entities.length) {
              this.selectedItem = this.entities[selectedIndex];
            }
          }
        }
        break;
    }
  }

  searchKeyup() {
    if(this.lastSearch !== this.search) {
      this.lastSearch = this.search;

      if(this.searchTimer) {
        window.clearTimeout(this.searchTimer);
      }

      this.searchTimer = window.setTimeout(() => {
        this.apply();
      }, 500);
    }
  }

  windowClick(event: Event) {
    if ((event.target as Element).closest('.filter') !== this.host.nativeElement) {
      this.close();
    }
  }
}
